<template>
  <div class="memberList">
    <v-card class="cardWrap">
      <CardTitle title="ChatBox" />
      <v-data-table
        :headers="headers"
        :items="desserts"
        hide-default-footer
        class="elevation-1"
        sort-by="memberNo">
        <template v-slot:top>
        <v-form ref="form" lazy-validation>
          <v-toolbar flat color="white" class="mt-1">
                <v-text-field
                    class="mr-3 pt-4"
                    v-model="search"
                    append-icon="mdi-account-search"
                    label="氏名"
                />
                <v-select
                    class="mr-3 selectWidth pt-4"
                    :items="Itemlist"
                    item-value="golf_code"
                    item-text="golf_name"
                    v-model="golf_code"
                    label="ゴルフ場を選択"
                    v-if="golfSelect.length > 1"
                    :rules="[rules.required_golf_course]"
                ></v-select>
                ステータス：<v-radio-group
                    class="status_radio float-right"
                    v-model="searchOption"
                    row>
                    <v-radio
                        class="pt-4"
                        v-for="d in searchOptionList"
                        :key="d.id"
                        :label="d.code_name"
                        :value="d.code" />
                </v-radio-group>
                表示順：<v-radio-group
                    v-model="sortOption"
                    row>
                    <v-radio
                        class="pt-4"
                        v-for="d in sortOptionList"
                        :key="d.id"
                        :label="d.code_name"
                        :value="d.code" />
                </v-radio-group>
                <v-spacer></v-spacer>
                <!-- <v-checkbox
                    class="mr-3 selectWidth pt-4"
                    v-model="completed"
                    label="未返信メッセージあり"
                /> -->

            <v-btn
                class="mr-2"
                color="primary"
                v-on:click="clickSearch"
                :disabled="btn[0].isActive"
                >検索
            </v-btn>
          </v-toolbar>
        </v-form>
        </template>
        <template v-slot:[`item.message`]="{ item }">
          <v-icon
            :disabled="btn[1].isActive"
            @click="MessageListOpen(item)">mdi-message-text-outline</v-icon>
        </template>
        <template v-slot:[`item.completed_name`]="{ item }">
          <span :class="getColor(item)">{{ item.completed_name }}</span>
        </template>
      </v-data-table>
      <v-pagination
        class="my-2"
        v-model="page"
        :length="pageCount"
        :total-visible="7"
        @input="clickPagination"
      ></v-pagination>
    </v-card>
    <!-- <MemberModal ref="MemberAddView" @refresh-event="getMessageList"/>
    <MemberCard ref="MemberCardView" @refresh-event="getMessageList" :golfCourseSelection="Itemlist" :golfCourseInput="golf_code"/>
    <MemberClassfication ref="MemberClassficationView" @refresh-event="getMessageList" :golfCourseSelection="Itemlist" :golfCourseInput="golf_code"/>
    <MemberPointHistoryModal ref="PointHistoryView" @refresh-event="getMessageList" :adminInfo="admin" :golfGroupInfo="golf_groups" :golfCourseInput="golf_code"/> -->
    <MessageList ref="MessageView" @refresh-event="getMessageList" :adminInfo="admin" :received="passTo" :golfCourseSelection="Itemlist"/>
  </div>
</template>

<script>
import CardTitle from '../../components/module/CardTitle';
// import MemberModal from './modal/Member';
// import MemberCard from './modal/MemberCard';
// import MemberClassfication from './modal/MemberClassfication';
// import MemberPointHistoryModal from './modal/MemberPointHistory';
import MessageList from './../Message/MessageList';
// import validater from '@/lib/validater';

// import { CODE_MASTER } from '../config';
// サンプルデータ（ポイント残数）
// import SamplePointData from '../../assets/data/sample_point.json';

import { MEMBER_LIST_INITIAL_DISPLAY } from '../../constants/member_list';
import { GET_ALL_CONTACT_MESSAGE_LIST } from '../../constants/contact';
import { authorityMixin } from '@/views/authorityMixin';
import { utilityMixin } from '@/mixins/utility';
import { codeListMixin } from '@/mixins/codeList';
import { GET_OPERATION_ACCESSES_LIST } from '@/constants/operation_accesses';
import { GET_LOGIN_ADMIN } from '@/constants/login';
import { CODE_MASTER } from '../config';

export default {
    components: {
        CardTitle,
        // MemberModal,
        // MemberCard,
        // MemberClassfication,
        // MemberPointHistoryModal,
        MessageList
    },
    mixins: [
        authorityMixin,
        utilityMixin,
        codeListMixin
    ],
    props: ['name'],
    data () {
        return {
            page: 1,
            pageCount: 0,
            // 検索キーワード
            search: '',
            inputName: '',
            // コードマスタ
            codeList: [],
            searchOptionList: [],
            searchOption: 9,
            inputSearchOption: null,
            sortOptionList: [
                { id: 1, code_name: 'ステータス順', code: 1 },
                { id: 2, code_name: '会員番号順', code: 2 }
            ],
            sortOption: 1,
            inputSortOption: null,
            Itemlist: [],
            // データテーブルに渡す値
            desserts: [],
            // データテーブルの見出し要素
            headers: [
                { text: '会員No', sortable: false, value: 'member_no' },
                { text: '氏名', align: 'left', sortable: false, value: 'name' },
                { text: '会員区分', align: 'left', sortable: false, value: 'code_name' },
                { text: '予約番号', align: 'left', sortable: false, value: 'display_reserve_no' },
                { text: 'メッセージ', align: 'center', value: 'message', sortable: false },
                { text: '送受信日', value: 'created_at', sortable: false },
                { text: 'ステータス', value: 'completed_name', sortable: false }
            ],
            // 区分選択のセレクトエリアの表示値
            golf_groups: [],
            // ゴルフ場選択の制御
            golf_code: null,
            begin_row: 0,
            limit_rows: 10,
            golfSelect: [],
            // メッセージ画面に渡す情報
            passTo: {
                golfCode: '',
                reserve_no: ''
            },
            // ログインしている者の情報
            admin: {
                golf_code: '',
                user_div: '',
                user_id: '',
                point_use_type: ''
            },
            // ボタンの活性・非活性
            btn: [
                { element_id: '001', element_name: '検索', isActive: true },
                { element_id: '002', element_name: 'メッセージ表示', isActive: true }
            ],
            vue_id: 'SCR0106',
            rules: {
                required_golf_course: value => this.isRequired(value) || this.$t('error.validation.required.whenCardNoIs')
            },
            loadingCount: 0
        };
    },
    async created () {
        this.loadingOn();
        await this.$apollo.mutate({
            mutation: GET_LOGIN_ADMIN
        }).then(res => {
            this.admin.user_id = res.data.getLoginAdmin.user_id;
            this.admin.user_div = res.data.getLoginAdmin.login.user_div;
            this.admin.golf_code = res.data.getLoginAdmin.login.golf_code;
            return res.data.getLoginAdmin;
        });
        await this.initialFetch();

        this.admin.point_use_type = this.golf_groups[0].point_use_type;

        // システム管理者の場合
        if (this.admin.user_div === 1) {
            this.Itemlist = [];
            this.Itemlist = this.golfSelect;
            if (this.golfSelect.length > 1) {
                this.Itemlist.unshift({ golf_code: '', golf_name: '全て' });
            }
            this.golf_code = '';
        } else {
        // ゴルフ場担当者
            this.Itemlist = [];
            this.Itemlist.push(this.golfSelect.find(el => el.golf_code === this.admin.golf_code));
            this.golf_code = this.admin.golf_code;
        }
        // コードマスタより対応完了フラグの名称を取得
        this.codeList = await this.getCodeList('completed');
        this.searchOptionList = [
            { id: 1, code_name: this.codeList[0].code_name, code: 0 },
            { id: 2, code_name: this.codeList[1].code_name, code: 1 },
            { id: 3, code_name: '全て', code: 9 }
        ];
        this.inputName = this.search;
        this.inputSearchOption = this.searchOption;
        this.inputSortOption = this.sortOption;
        // this.getMember();
        this.getMessageList();
        await this.getAuthorityByMemberList();
        this.loadingOff();
    },
    computed: {
        // formatedDate: function () {
        //     return function (pdate) {
        //         pdate = this.addHyphen(pdate);
        //         return pdate;
        //     };
        // }
    },
    methods: {
        initialFetch () {
            return this.$apollo.mutate({
                mutation: MEMBER_LIST_INITIAL_DISPLAY,
                variables: {
                    golf_group_code: process.env.VUE_APP_GROUP_CODE
                }
            }).then(res => {
                this.golfSelect = res.data.getGolfCourse;
                this.golf_groups = res.data.getGolfGroupByMaster;
            });
        },
        getAuthorityByMemberList () {
            this.$apollo.mutate({
                mutation: GET_OPERATION_ACCESSES_LIST,
                variables: {
                    golf_group_code: process.env.VUE_APP_GROUP_CODE,
                    user_id: this.admin.user_id,
                    vue_id: this.vue_id,
                    element_id: ''
                }
            }).then(res => {
                let opeList = res.data.GetOperationAccessList.OperationAccessList;
                for (let list of opeList) {
                    this.btn.forEach(el => {
                        if (list.element_id === el.element_id) {
                            if (list.element_control === 0) {
                                el.isActive = true;
                            } else {
                                el.isActive = false;
                            }
                        }
                    });
                };
            });
        },
        /** --------------------------------------------
        * メッセージ一覧取得
        * -------------------------------------------- */
        async getMessageList () {
            this.loadingOn();
            this.passTo.reserve_no = '';
            this.passTo.golfCode = '';
            try {
                await this.$apollo
                    .mutate({
                        fetchPolicy: 'no-cache',
                        mutation: GET_ALL_CONTACT_MESSAGE_LIST,
                        variables: {
                            name: this.inputName,
                            completed: this.inputSearchOption,
                            sort_option: this.inputSortOption,
                            golf_group_code: process.env.VUE_APP_GROUP_CODE,
                            golf_code: this.golf_code,
                            begin_row: this.begin_row,
                            limit_rows: this.limit_rows
                        }
                    })
                    .then(res => {
                        const count = res.data.getAllMemberContactsMessageList.count;
                        this.pageCount = Math.ceil(count / this.limit_rows);
                        this.desserts = [];
                        if (!count) return;
                        this.desserts = res.data.getAllMemberContactsMessageList.MemberMessage;
                        this.desserts.forEach(el => {
                            el.name = el.family_name + ' ' + el.given_name;
                            if (el.reserve_no === CODE_MASTER.SUBSTITUTE_RESERVE_NO) {
                                el.display_reserve_no = el.golf_name;
                            } else {
                                el.display_reserve_no = el.reserve_no;
                            }
                        });
                    });
                this.loadingOff();
            } catch (error) {
                this.error = error;
                this.loadingOff();
            }
        },
        isRequired (value) {
            if (this.card_no) {
                if (value) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return true;
            }
        },
        /** ----------------------------------------------
        * メッセージボタン押下時の処理
        * @val 子画面に渡すモーダル表示制御値
        * @item 押下した行の情報
        * ---------------------------------------------- */
        MessageListOpen: function (item) {
            this.passTo.reserve_no = (item.reserve_no === CODE_MASTER.SUBSTITUTE_RESERVE_NO) || !item.reserve_no ? '' : item.reserve_no;
            this.passTo.golfCode = item.golf_code ? item.golf_code : this.golf_code;
            this.$refs.MessageView.ModalControl(item.member_no);
        },
        clickPagination: function () {
            this.begin_row = this.page * this.limit_rows - this.limit_rows;
            this.getMessageList();
        },
        clickSearch: function () {
            this.inputName = this.search;
            this.inputSearchOption = this.searchOption;
            this.inputSortOption = this.sortOption;
            this.page = 1;
            this.begin_row = 0;
            this.getMessageList();
        },
        /** --------------------------------------------
         * ステータス毎の文字色切り替え
         * 未対応：赤  送信済み、対応完了済み：黒
         * -------------------------------------------- */
        getColor (el) {
            if (el.completed === 0) {
                return 'redselect';
            } else if (el.completed === 1) {
                return 'blackselect';
            } else if (el.completed === 9) {
                return 'blackselect';
            }
        },
        /** ----------------------------------------------
         * ローディング開始
         * ---------------------------------------------- */
        loadingOn: function () {
            this.loadingCount++;
            this.$store.commit('loading/setIsLoading', true);
        },
        /** ----------------------------------------------
         * ローディング終了
         * ---------------------------------------------- */
        loadingOff: function () {
            this.loadingCount--;
            if (this.loadingCount === 0) {
                this.$store.commit('loading/setIsLoading', false);
            }
        }
    }
};
</script>

<style scoped>
.point_select {
  color: black;
  background: Transparent;
  text-decoration: underline;
}

.selectWidth {
    width: 195px;
}

.status_radio{
    padding-right: 2.0rem;
}

</style>
